import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The retired /projects/:projectId/settings/* route (2026-09-17). Project
 * Settings is now a modal on the issues page, opened by ?settings=<tab>, so an
 * old link (a bookmark, an email, the help chat) lands on the same tab there.
 * The modal maps a tab the viewer cannot see, and the old "accessibility" tab,
 * itself (resolveSettingsTab).
 */
export function ProjectSettingsRedirect() {
  const { projectId, '*': rest } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('settings', rest?.split('/')[0] || 'general');
  return <Navigate to={`/projects/${projectId}/issues?${params.toString()}`} replace />;
}
